(() => {
  const product = window.VRExperiments?.config;
  if (!product?.includedConsole || !product.variantOptions) return;
  const gifts = JSON.parse(document.getElementById('vr-included-config').textContent).map;
  const plans = new Map();
  let knownCartIds = product.cartVariantIds || [];
  const normalize = value => String(value || '').replace(/\s+/g,'').toLowerCase();
  const rootLines = items => items.filter(item=>!item.parent_id && !item.parent_line_key);
  function giftPlan(parent, items) {
    const nativeValues = product.variantOptions[parent.id];
    if (!nativeValues) return null;
    const native = names => {
      const index = product.optionNames.findIndex(name=>names.includes(name.trim().toLowerCase()));
      return index < 0 ? '' : nativeValues[index];
    };
    const props = parent.properties || {};
    const hardware = normalize(props.Mod || props['Hardware-Modifikation'] || props['Hardware modification'] || native(['ladeport','ladeanschluss','mod','hardware-modifikation','hardware modification','charging port']) || 'Original');
    const storage = normalize(props.Speicher || props.Storage || native(['speicher','storage']) || product.baseStorage);
    const storageChild = items.some(item=>Number(item.parent_id)===Number(parent.id) && item.properties?._bundle_kind==='storage');
    const promoIds = window.VR3DSPromo?.giftsForSource(product.includedAccessories?.['3-ersatz-stifte-fur-den-3ds-xl']?.variantId) || [];
    const key = [parent.id,hardware,storage,storageChild,promoIds.join(',')].join('|');
    if (plans.has(key)) return plans.get(key);
    const handles = [];
    if (product.standardCableHandle && (!hardware.includes('usb') || hardware.includes('capture'))) handles.push(product.standardCableHandle);
    if (hardware.includes('usb') || hardware.includes('capture')) handles.push('usb-c-ladekabel');
    if (!storageChild && (storage===normalize(product.baseStorage) || product.nativeIncludedStorage)) {
      handles.push(storage==='32gb' ? '32gb-speicher' : storage==='128gb' ? '128gb-speicher-upgrade-fur-nintendo-3ds' : 'storage-'+storage);
    }
    if (product.includedAccessories?.['3-ersatz-stifte-fur-den-3ds-xl']?.variantId>0) handles.push('3-ersatz-stifte-fur-den-3ds-xl');
    if (product.vitaTv) handles.push('ps3-controller');
    const resolved = handles.map(handle=>gifts[product.includedAccessories?.[handle]?.variantId]?.id);
    resolved.push(...promoIds);
    const plan = resolved.every(id=>Number.isSafeInteger(id)&&id>0) ? [...new Set(resolved)] : null;
    plans.set(key,plan);
    return plan;
  }
  function expand(items, confirmedCart) {
    const existing = new Set(confirmedCart ? confirmedCart.items.map(item=>Number(item.id)) : knownCartIds.map(Number));
    const roots = rootLines(items);
    const extra = roots.flatMap(parent=>{
      if (existing.has(Number(parent.id)) || roots.filter(item=>Number(item.id)===Number(parent.id)).length!==1) return [];
      const plan = giftPlan(parent,items);
      if (!plan) return [];
      return plan.filter(id=>!items.some(item=>Number(item.id)===id && Number(item.parent_id)===Number(parent.id))).map(id=>({
        id,quantity:Number(parent.quantity || 1),parent_id:Number(parent.id),properties:{_bundle_hidden:'true',_bundle_kind:'included'}
      }));
    });
    return [...items,...extra];
  }
  function prepareSelection() {
    document.querySelectorAll('product-form form[action*="/cart/add"]').forEach(form=>{
      const data = new FormData(form);
      const id = Number(data.get('id'));
      if (!product.variantOptions[id]) return;
      const properties = Object.fromEntries([...data.entries()].flatMap(([key,value])=>{
        const match = key.match(/^properties\[(.+)]$/); return match ? [[match[1],value]] : [];
      }));
      const addons = window.ConsoleAddons?.getForForm(form);
      const items = addons?.buildLines({variantId:id,quantity:Number(data.get('quantity')||1),properties}) || [{id,quantity:1,properties}];
      giftPlan(items[0],items);
    });
  }
  window.VRCartPlan = {expand,prepareSelection,giftPlan,setCart:cart=>{knownCartIds=cart.items.map(item=>item.id);}};
  const prepare = () => queueMicrotask(prepareSelection);
  document.addEventListener('change',prepare);
  document.addEventListener('console-addons:change',prepare);
  const start = () => {
    if (typeof subscribe==='function') subscribe(PUB_SUB_EVENTS.variantChange,prepare);
    prepareSelection();
    window.VRCheckoutContents.prime();
  };
  if (document.readyState==='loading' || !window.VRCheckoutContents) document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
